import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../shared/data/queryKeys';
import { searchTranscripts, type SearchParams } from './api';

export function useSearchTranscripts(params: SearchParams, enabled: boolean) {
  const { q, ...rest } = params;
  return useQuery({
    queryKey: queryKeys.search(q, rest as Record<string, unknown>),
    queryFn: () => searchTranscripts(params),
    enabled: enabled && q.trim().length >= 2,
  });
}
